<template>
    <div class="flex property" style="margin-top: 0.38rem; height: .5rem;" >
        <div class="left flex1" >
            <p class="small_font property-num">指导员</p>
            <div class="nomal_font property-name ellipsis leader" style="font-size: 13px;line-height: .2rem" v-if="idolInfo != undefined">
            	{{idolInfo.nick}}
            	<br />
            </div>
            <p class="nomal_font property-name" v-else>
            	平台
            </p>
          <div v-if="idolInfo != undefined" class="icon-member">
            <!--<img src="../../../static/img/ixz.png"-->
                 <!--style="width: 0.15rem;  position: relative; top: 3px;"/>-->

            <member-level :user-info="idolInfo">
            </member-level>
          </div>
        </div>
        <!-- <div class="border"></div> -->
        <div class="left flex1" @click="ownRankItem">
            <p class="small_font property-num">本周排名</p>
            <p class="nomal_font property-name property-name-center" style="line-height: .38rem;font-size: 0.2rem;font-weight: 1000;">{{ ownRank.ranking ? ownRank.ranking : `${ownRank.overRanking}+` }}</p>
        </div>
        <!-- <div class="border"></div> -->
        <div class="right flex1" @click="jumpToProfit">
        	<p class="small_font property-num">{{ menuTypes.balance }}</p>
            <p class="nomal_font property-name" style="    line-height: 0.38rem;font-size: 0.2rem;font-weight: 1000;">{{ property.balance / 100 }}</p>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import MemberLevel from './components/MemberLevel';

export default {
  name: 'Property',
  props: ['menuTypes', 'property','userInfo', 'ownRank','idolInfo'],
  components: {
    MemberLevel,
  },
  computed:{
    ...mapGetters('user', {
      levelList: 'getMemberLevelList',
    }),
  },
  data() {
    return {
      options: {
        title: '冻结原因：',
        content: '申请提现部分及发放不满7天的'
      },
    }
  },
  methods: {
    jumpToProfit: function() {
        this.$router.push('user/profit')
    },
    ownRankItem: function(){
      this.$router.push('/user/rank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.property {
  .border0 {
    border: 0;
  }
  &-num {
    font-weight: 500;
  }
  &-name {
    margin-top: .01rem;
    height: .22rem;
    line-height: .2rem;
    font-size: .16rem;
    font-weigth: 500;

  }
}
.property-name-center {
  border-right: .01rem solid #fff;
  border-left: .01rem solid #fff;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
  .leader {
    width: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/userElement/Property.vue